var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 603.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e21d38;}.cls-3,.cls-4{fill:#204389;}.cls-5{letter-spacing:.13em;}.cls-4{font-family:Montserrat-Italic, Montserrat;font-size:73.32px;font-style:italic;}.cls-6{letter-spacing:.15em;}.cls-7{letter-spacing:.14em;}.cls-8{letter-spacing:.15em;}.cls-9{letter-spacing:.15em;}.cls-10{letter-spacing:.15em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.08,
    y: 27.6,
    width: 949.84,
    height: 154.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.29,131.59v17.14H81.82V56.43h69.75v17.14h-48.52v20.04h42.85v16.62h-42.85v21.36h50.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.94,56.43v92.3h-17.54l-46.02-56.04v56.04h-21.1V56.43h17.67l45.89,56.04V56.43h21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.48,56.43v92.3h-21.36v-37.84h-41.93v37.84h-21.36V56.43h21.36v36.39h41.93V56.43h21.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.15,128.95h-42.85l-8.18,19.78h-21.89l41.14-92.3h21.1l41.28,92.3h-22.42l-8.18-19.78Zm-6.72-16.22l-14.63-35.34-14.64,35.34h29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M569.02,56.43v92.3h-17.54l-46.02-56.04v56.04h-21.1V56.43h17.67l45.89,56.04V56.43h21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.11,102.58c0-27.82,21.36-47.73,50.1-47.73,15.95,0,29.27,5.8,37.98,16.35l-13.71,12.66c-6.2-7.12-13.98-10.81-23.21-10.81-17.28,0-29.54,12.13-29.54,29.54s12.26,29.54,29.54,29.54c9.23,0,17.01-3.69,23.21-10.94l13.71,12.66c-8.7,10.68-22.02,16.48-38.11,16.48-28.61,0-49.97-19.91-49.97-47.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M687.55,56.43h21.36v92.3h-21.36V56.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M815.45,56.43v92.3h-17.54l-46.02-56.04v56.04h-21.1V56.43h17.67l45.89,56.04V56.43h21.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M899.7,101.13h19.52v37.45c-10.15,7.65-24.13,11.74-37.32,11.74-29.01,0-50.37-19.91-50.37-47.73s21.36-47.73,50.77-47.73c16.22,0,29.67,5.54,38.63,15.95l-13.72,12.66c-6.72-7.12-14.5-10.42-23.86-10.42-17.93,0-30.19,12-30.19,29.54s12.26,29.54,29.93,29.54c5.8,0,11.21-1.05,16.61-3.96v-27.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.7,261.69c0-27.78,21.64-48.35,51.16-48.35s51.16,20.44,51.16,48.35-21.77,48.35-51.16,48.35-51.16-20.57-51.16-48.35Zm80.41,0c0-17.77-12.56-29.92-29.25-29.92s-29.25,12.15-29.25,29.92,12.56,29.92,29.25,29.92,29.25-12.15,29.25-29.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.78,214.94v93.5h-17.76l-46.62-56.77v56.77h-21.37v-93.5h17.9l46.48,56.77v-56.77h21.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.53,261.69c0-28.18,21.64-48.35,50.76-48.35,16.16,0,29.65,5.88,38.47,16.56l-13.89,12.82c-6.28-7.21-14.16-10.95-23.51-10.95-17.5,0-29.92,12.29-29.92,29.92s12.42,29.92,29.92,29.92c9.35,0,17.23-3.74,23.51-11.09l13.89,12.82c-8.81,10.82-22.31,16.69-38.6,16.69-28.98,0-50.62-20.17-50.62-48.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M415.12,261.69c0-27.78,21.64-48.35,51.16-48.35s51.16,20.44,51.16,48.35-21.77,48.35-51.16,48.35-51.16-20.57-51.16-48.35Zm80.41,0c0-17.77-12.56-29.92-29.25-29.92s-29.25,12.15-29.25,29.92,12.55,29.92,29.25,29.92,29.25-12.15,29.25-29.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.3,214.94h21.64v75.87h46.89v17.63h-68.52v-93.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M617.94,261.69c0-27.78,21.64-48.35,51.16-48.35s51.16,20.44,51.16,48.35-21.77,48.35-51.16,48.35-51.16-20.57-51.16-48.35Zm80.41,0c0-17.77-12.56-29.92-29.25-29.92s-29.25,12.15-29.25,29.92,12.55,29.92,29.25,29.92,29.25-12.15,29.25-29.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M803.05,260.22h19.77v37.93c-10.29,7.75-24.44,11.89-37.8,11.89-29.38,0-51.02-20.17-51.02-48.35s21.64-48.35,51.42-48.35c16.43,0,30.06,5.61,39.14,16.16l-13.89,12.82c-6.81-7.21-14.69-10.55-24.17-10.55-18.17,0-30.59,12.15-30.59,29.92s12.42,29.92,30.32,29.92c5.88,0,11.35-1.07,16.83-4.01v-27.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M898.27,275.31v33.13h-21.64v-33.39l-36.2-60.11h22.98l24.98,41.54,24.98-41.54h21.24l-36.33,60.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.08,
    y: 349.17,
    width: 949.84,
    height: 154.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.68,474.53l-.14-57.96-28.43,47.75h-10.07l-28.29-46.51v56.72h-20.98v-96.6h18.49l36.16,60.03,35.6-60.03h18.35l.27,96.6h-20.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.88,426.23c0-28.7,22.35-49.95,52.85-49.95s52.85,21.12,52.85,49.95-22.49,49.95-52.85,49.95-52.85-21.25-52.85-49.95Zm83.07,0c0-18.35-12.97-30.91-30.22-30.91s-30.22,12.56-30.22,30.91,12.97,30.91,30.22,30.91,30.22-12.55,30.22-30.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.67,377.93h43.88c31.6,0,53.26,19.04,53.26,48.3s-21.67,48.3-53.26,48.3h-43.88v-96.6Zm42.78,78.24c19.18,0,31.74-11.45,31.74-29.95s-12.55-29.94-31.74-29.94h-20.42v59.89h20.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M738.16,456.59v17.94h-74.79v-96.6h73v17.94h-50.78v20.98h44.85v17.38h-44.85v22.36h52.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M853.88,377.93h22.35v78.38h48.44v18.22h-70.79v-96.6Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(34.87 582.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 0,
    y: 0
  }, "SU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 125.16,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 188.07,
    y: 0
  }, "PO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 324.23,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 387.5,
    y: 0
  }, "T NE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 601.45,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 654.17,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 745.09,
    y: 0
  }, "ORK"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEom);
export default __webpack_public_path__ + "static/media/eom.5d0b8c900293223932afc75a47769cb0.svg";
export { ForwardRef as ReactComponent };